/// <reference path="../../common/notifications/notifications.ts" />

namespace OfficeGuy.Apps {
    export class CreditGuy {
        static InitPayments(): void {
            $(".og-creditguy-amount, #CreditTerms, .og-creditguy-payments-paymentscount input, .og-creditguy-payments input").on("input", function () {
                CreditGuy.RefreshPayments($(this));
            });
            CreditGuy.RefreshPayments($(this));
        }

        static RefreshPayments(Initiator): void {
            var PaymentsCount = Number($(".og-creditguy-payments-paymentscount input").val());
            var Total = Number($(".og-creditguy-amount input").val());
            var IsPayments = PaymentsCount > 1 && $("#CreditTerms").val() == "8";
            $(".og-creditguy-payments-paymentscount").toggle($("#CreditTerms").val() != "1");
            $(".og-creditguy-payments").toggle(IsPayments);
            var $FirstPaymentElement = $(".og-creditguy-payments-paymentsfirstamount input");
            var $EachPaymentElement = $(".og-creditguy-payments-paymentsnonfirstamount input");
            if (!IsPayments) {
                if ($("#CreditTerms").val() == "1")
                    $(".og-creditguy-payments-paymentscount input").val("1");
                $FirstPaymentElement.val("0");
                $EachPaymentElement.val("0");
                return;
            }

            if ($FirstPaymentElement.val() != '' && !isNaN(Number(<string>$FirstPaymentElement.val()))
                && $EachPaymentElement.val() != '' && !isNaN(Number(<string>$EachPaymentElement.val()))
                && Number($FirstPaymentElement.val()) + (PaymentsCount - 1) * Number($EachPaymentElement.val()) == Total) {
                return;
            }

            if (Initiator != null && Initiator[0] == $FirstPaymentElement[0]) {
                var EachPayment = Math.round(100 * (Total - Number($FirstPaymentElement.val())) / (PaymentsCount - 1)) / 100;
                var FirstPayment = Math.round(100 * (Total - EachPayment * (PaymentsCount - 1))) / 100;
                $FirstPaymentElement.val(FirstPayment.toString());
                $EachPaymentElement.val(EachPayment.toString());
            }
            else if (Initiator != null && Initiator[0] == $EachPaymentElement[0]) {
                var EachPayment = Math.round(100 * Number($EachPaymentElement.val())) / 100;
                var FirstPayment = Math.round(100 * (Total - EachPayment * (PaymentsCount - 1))) / 100;
                $FirstPaymentElement.val(FirstPayment.toString());
                $EachPaymentElement.val(EachPayment.toString());
            }
            else {
                var EachPayment = Math.round(100 * Total / PaymentsCount) / 100;
                var FirstPayment = Math.round(100 * (Total - EachPayment * (PaymentsCount - 1))) / 100;
                $FirstPaymentElement.val(FirstPayment.toString());
                $EachPaymentElement.val(EachPayment.toString());
            }
        }
    }
}